// extracted by mini-css-extract-plugin
export default {"root":"FileChip_root__k5Hp4","icon":"FileChip_icon__BNr6h"};